/* app/js/src/components/calendar/calendar-header/calendar-header.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  color: #232f3a;
}
.header-ribbon {
  width: 100%;
  height: 100px;
  background-color: rgb(238, 242, 246);
  border: solid 1px rgb(226, 230, 233);
  position: relative;
  margin-bottom: 15px;
}
.header-ribbon .header-ribbon-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -moz-box-orient: horizontal;
  -ms-box-orient: horizontal;
  box-orient: horizontal;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  margin: 3px 50px 3px 10px;
  justify-content: space-between;
}
.header-ribbon .header-ribbon-container .header-ribbon-box {
  justify-content: center;
  min-width: 128px;
  height: 80%;
  text-align: center;
  padding-top: 15px;
  color: #232f3a;
}
.header-ribbon .header-ribbon-container .header-ribbon-box .description-text {
  padding-top: 3px;
  height: 11px;
  line-height: 13px;
  font-size: 12px;
  text-transform: uppercase;
}
.header-ribbon .header-ribbon-container .header-ribbon-box .description-text span {
  display: inline-block;
  width: 110px;
  text-align: left;
}
.header-ribbon .header-ribbon-container .header-ribbon-box calendar-header-dropdown {
  align-self: center;
}
.header-ribbon .header-ribbon-container .header-ribbon-current-show {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  box-orient: vertical;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.header-ribbon .header-ribbon-container .header-ribbon-current-show.flex-2 {
  -webkit-flex: 2;
  -ms-flex: 2;
  flex: 2;
}
.header-ribbon .header-ribbon-container .header-ribbon-current-show .show-title {
  height: 15px;
  line-height: 19px;
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 8px;
}
.header-ribbon .header-ribbon-container .header-ribbon-current-show .show-title span.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  display: inline-block;
}
.header-ribbon .header-ribbon-container .header-ribbon-current-show .show-time {
  height: 33px;
  line-height: 30px;
  font-size: 24px;
  font-weight: 300;
  color: #40c4ff;
}
.header-ribbon .header-ribbon-container .header-ribbon-current-show .show-time.remaining {
  color: #ef5350;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -moz-box-orient: horizontal;
  -ms-box-orient: horizontal;
  box-orient: horizontal;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  justify-content: center;
  align-items: center;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show > div {
  margin-right: 20px;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .skip-oval {
  width: 43px;
  height: 43px;
  cursor: pointer;
  background-color: #ffffff;
  color: #ef5350;
  border-radius: 50%;
  margin-top: 4px;
  font-size: 17px;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .skip-oval.icon-filter-menu-top-arrow::before {
  line-height: 46px;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .skip-oval:hover {
  background-color: #ef5350;
  color: #ffffff;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .skip-oval:hover:active {
  background-color: #ffffff;
  color: #ef5350;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .description-text {
  padding-top: 0;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: bold;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .next-shows-dropdown {
  text-align: left;
  align-self: flex-end;
  flex-basis: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show .next-shows-dropdown .description-text {
  padding-top: 8px;
  text-transform: uppercase;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show.skipping {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show.skipping .skip-oval {
  cursor: progress;
}
.header-ribbon .header-ribbon-container .header-ribbon-skip-show.skipping .skip-oval:hover {
  background-color: #ffffff;
  color: #ef5350;
}
.header-ribbon .minimize-ribbon {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  padding: 10px 5px;
  position: absolute;
  right: 50%;
  bottom: -26px;
  background-color: inherit;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
}
.header-ribbon .minimize-ribbon::before {
  content: " ";
  position: absolute;
  top: -10%;
  height: 120%;
  left: -4px;
  width: 6px;
  background-color: inherit;
}
.header-ribbon .minimize-ribbon svg path {
  fill: #879baf;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.header-ribbon .minimize-ribbon:hover svg path {
  fill: #232f3a;
}
.header-ribbon.minimized {
  height: 7px;
}
.header-ribbon.minimized .header-ribbon-container {
  display: none;
}
.header-ribbon.minimized .minimize-ribbon svg path {
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
nav {
  height: 28px;
  position: relative;
  font-weight: bold;
}
nav .btn-group .btn {
  background: none;
  border: 1px solid #e3e6ea;
  color: #879baf;
  font-size: 10px;
  font-weight: bold;
  padding: 0 12px 0 12px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .btn-group .btn:hover {
  cursor: pointer;
  background-color: #dde3e7;
}
nav .btn-group .btn.active {
  background-color: #dde3e7;
  border-color: #40c4ff;
  color: #232f3a;
  z-index: 2;
}
nav .btn-group .btn + .btn {
  margin-left: -1px;
}
nav .btn-group .btn:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
nav .btn-group .btn:last-child {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
nav .toolbar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  bottom: 0;
  position: static;
  top: 0;
}
nav .toolbar > * {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  -ms-grid-row-align: stretch;
  align-self: stretch;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
nav .left-navigation {
  padding-left: 1vw;
}
nav .left-navigation .calendar-view-options .button {
  width: 30px;
  height: 26px;
  margin-right: 4px;
  display: inline-block;
  position: relative;
  border: solid 1px #e1e6eb;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .left-navigation .calendar-view-options .button ::ng-deep svg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  fill: #879baf;
}
nav .left-navigation .calendar-view-options .button ::ng-deep svg path {
  fill: #abbed0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .left-navigation .calendar-view-options .button.active ::ng-deep svg path {
  fill: #232f3a;
}
nav .left-navigation .calendar-view-options .button:hover {
  background-color: #ffffff;
}
nav .left-navigation .calendar-view-options .button:hover ::ng-deep svg path {
  fill: #232f3a;
}
nav .left-navigation .now-btn {
  background-color: #ffffff;
  border: solid 1px #e1e6eb;
  border-radius: 4px;
  font-size: 10px;
  font-weight: bold;
  width: 61px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .left-navigation .now-btn:hover {
  cursor: pointer;
  background-color: #eef2f6;
}
nav .left-navigation .adjacent-button {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: space-around;
  justify-content: space-around;
  -ms-flex-item-align: center;
  -ms-grid-row-align: center;
  align-self: center;
  padding: 0 2px;
  height: 25px;
  margin-left: 9px;
}
nav .left-navigation .nav-date-btn,
nav .left-navigation .next-btn,
nav .left-navigation .prev-btn {
  background: none;
  width: 26px;
  height: 26px;
  border-color: #e1e6eb;
  border-style: solid;
  border-top-width: 1px;
  border-bottom-width: 1px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .left-navigation .nav-date-btn svg path,
nav .left-navigation .next-btn svg path,
nav .left-navigation .prev-btn svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  fill: #e1e6eb;
}
nav .left-navigation .nav-date-btn:hover,
nav .left-navigation .next-btn:hover,
nav .left-navigation .prev-btn:hover {
  cursor: pointer;
}
nav .left-navigation .nav-date-btn:hover svg path,
nav .left-navigation .next-btn:hover svg path,
nav .left-navigation .prev-btn:hover svg path {
  fill: #879baf;
}
nav .left-navigation .prev-btn {
  border-left-width: 1px;
  border-radius: 4px 0 0 4px;
  border-right-width: 0px;
}
nav .left-navigation .prev-btn:active {
  background: -moz-linear-gradient(left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 70%);
  background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 70%);
  background:
    linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.05) 100%);
}
nav .left-navigation .next-btn {
  border-right-width: 1px;
  border-radius: 0 4px 4px 0;
  border-left-width: 1px;
}
nav .left-navigation .next-btn:active {
  background: -moz-linear-gradient(right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 70%);
  background: -webkit-linear-gradient(right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.05) 70%);
  background:
    linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.05) 100%);
}
nav .left-navigation .calendar-title {
  margin-left: 13px;
  color: #232f3a;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  position: relative;
  cursor: pointer;
}
nav .left-navigation .calendar-title .calendar-icon {
  padding-left: 9px;
  opacity: 0;
  -ms-transform: translateX(2px);
  -webkit-transform: translateX(2px);
  transform: translateX(2px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .left-navigation .calendar-title .calendar-icon svg {
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .left-navigation .calendar-title .calendar-icon svg rect {
  fill: none;
}
nav .left-navigation .calendar-title .calendar-icon svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  fill: #879baf;
}
nav .left-navigation .calendar-title .calendar-icon svg:hover {
  color: #757575;
}
nav .left-navigation .calendar-title .calendar-icon svg:hover path {
  fill: #757575;
}
nav .left-navigation .calendar-title .calendar-icon svg:active {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  color: #232f3a;
}
nav .left-navigation .calendar-title .calendar-icon svg:active path {
  fill: #232f3a;
}
nav .left-navigation .calendar-title:hover .calendar-icon {
  -ms-transform: translateX(0);
  -webkit-transform: translateX(0);
  transform: translateX(0);
  opacity: 1;
}
nav icn-calendar-search {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 18vw;
}
nav > section {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
}
nav > section .right-navigation {
  padding-right: 1vw;
  opacity: 1;
  -ms-transform: translateX(0vw);
  -webkit-transform: translateX(0vw);
  transform: translateX(0vw);
  -webkit-transition: all 0.5s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.5s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
nav > section .right-navigation.hidden {
  -ms-transform: translateX(50vw);
  -webkit-transform: translateX(50vw);
  transform: translateX(50vw);
  opacity: 0;
}
.filter-sec-events-container,
.customize-table-columns-container {
  display: flex;
  position: absolute;
  align-items: center;
  top: 0;
  bottom: 0;
  right: 39px;
  z-index: 4;
  -webkit-user-select: none;
  user-select: none;
}
.customize-table-columns-container {
  right: 200px;
}
.customize-table-columns-container svg path {
  fill: rgb(123, 144, 164);
}
.filter-hidden,
.customize-table-columns-hidden {
  display: none;
}
.filter-sec-events-title,
.customize-table-columns-title {
  display: flex;
  align-items: center;
  margin-right: 7.36px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.sec-events-filter-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}
/*# sourceMappingURL=calendar-header.component.css.map */
